var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewServiceHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    height: "2.22rem",
    width: "2.22rem",
    alt: "Service History Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View_Service__History",
    "data-name": "View_Service_History"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.28,2.22A22.56,22.56,0,0,0,5.71,18.1h-2l-2.49,0a1.09,1.09,0,0,0-.94,1.67l4.67,7.73a1.09,1.09,0,0,0,1.86,0l4.76-7.7a1.08,1.08,0,0,0-.93-1.66H7.8A20.63,20.63,0,0,1,47.92,25,20.62,20.62,0,0,1,8.38,33.37a1,1,0,0,0-1.32-.51,1,1,0,0,0-.51,1.31A22.68,22.68,0,1,0,27.28,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.28,10.07a1,1,0,0,0-1,1V22.79a3.76,3.76,0,1,0,3.66,6.5l7.13,4.28a1.06,1.06,0,0,0,.51.14,1,1,0,0,0,.86-.48,1,1,0,0,0-.34-1.38L30.18,27.7a3.75,3.75,0,0,0-2.9-5.13V11.07A1,1,0,0,0,26.28,10.07Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewServiceHistory);
export default __webpack_public_path__ + "static/media/ViewServiceHistory.2f78fb7d.svg";
export { ForwardRef as ReactComponent };